import T from "../theme/colors";

export default function PageHeader({ title, subtitle, actions, breadcrumb }) {
  return (
    <div style={{ marginBottom: 20 }}>
      {breadcrumb && (
        <div style={{ fontSize: 13, color: "var(--text-2)", marginBottom: 6, display: "flex", alignItems: "center", gap: 5 }}>
          {breadcrumb.map((b, i) => (
            <span key={i} style={{ display: "flex", alignItems: "center", gap: 5 }}>
              {i > 0 && <span style={{ color: "var(--border)", fontSize: 12 }}>›</span>}
              <span style={{ color: i === breadcrumb.length - 1 ? "var(--text-1)" : "var(--text-2)" }}>{b}</span>
            </span>
          ))}
        </div>
      )}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
        <div>
          <h1 style={{
            fontSize: 23, fontWeight: 600, color: "var(--text-0)",
            fontFamily: "var(--font-display)",
            letterSpacing: "-0.01em",
          }}>
            {title}
          </h1>
          {subtitle && (
            <p style={{ fontSize: 15, color: "var(--text-1)", marginTop: 2 }}>{subtitle}</p>
          )}
        </div>
        {actions && (
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
